module["exports"] = [
  "#{city_prefix}#{city_suffix}"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_TW/address/city.js
// module id = 1681
// module chunks = 1